import {
    Box,
    Divider,
    Flex,
    Heading,
    Text
} from "@chakra-ui/react";
const InvestmentHighlight = (props) => {
    return (
        <Box fontSize="14px" fontWeight="500">
            <Heading textAlign="center" fontSize="26px" fontWeight="600">Investment Highlight</Heading>
            <Divider my="30px" />
            <Flex w="100%" flexDirection={{ base: "column", md: "row" }} wrap="wrap">
                {!props.data || props.data?.length == 0 ?
                    <Text w="100%" textAlign="center" my="50px">No items to Display</Text>
                    :
                    props.data?.map((investmentHighlight, index) => {
                        return (
                            <Box key={index} w={{ base: "100%", md: "50%" }} p="24px" mb="30px">
                                <Heading fontSize="20px" fontWeight="500" mb="8px">{investmentHighlight.title}</Heading>
                                <Text>
                                    {investmentHighlight.description}
                                </Text>
                            </Box>
                        );
                    }
                    )}
            </Flex>
        </Box>
    );
}

export default InvestmentHighlight;